import { __ } from '@wordpress/i18n';
import { PanelBody, SelectControl, RangeControl, TextControl} from '@wordpress/components';
import {VayuBlocksToggleControl,VayuBlocksAlignment, IconSelector, HeightControl} from '@vayu-blocks';
import { SlideButton } from '@vayu-blocks/global';
import {
  __experimentalToggleGroupControl as ToggleGroupControls,
  __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
} from '@wordpress/components';
import { Icon,justifyLeft, justifyRight} from '@wordpress/icons';
import { useSelect } from '@wordpress/data';

const Toc = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

	// Handle individual toggle updates
	const handleChange = (value, level) => {
		const newHeading = {
			...attributes.heading,
			[level]: value,
		};
		setAttributes({ heading: newHeading });
	};

	// const isSiteEditor = useSelect((select) =>
	// 	select('core/edit-site') !== undefined
	// );

	return (
		<>
			<PanelBody
				title={__('General', 'vayu-blocks')}
				opened={openPanels['toc-panel']}
				onToggle={() => onTogglePanel('toc-panel')}
			>

				<p className="vb-toc-toc-para">{__('Choose heading tags to generate table', 'vayu-blocks')}</p>
				<div className="vb-toc-toc-div">
					{['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map((level) => (
						<VayuBlocksToggleControl
							key={level}
							label={level.toUpperCase()}
							checked={attributes.heading?.[level]}
							onChange={(value) => handleChange(value, level)}
						/>
					))}
				</div>

				<br/>

				<SelectControl
					label={__('Hierarchy Type', 'vayu-blocks')}
					value={attributes.hierarchyType}
					options={[
						{ label: 'Nested by Heading Levels', value: 'nested' },
						{ label: 'Flat List', value: 'flat' },
						{ label: 'Limited Nesting', value: 'limited' },
						{label: 'Deep-Numbered', value: 'deep-numbered'},
					]}
					onChange={(value) => setAttributes({ hierarchyType: value })}
				/>

			</PanelBody>

			<PanelBody
				title={__('Settings', 'vayu-blocks')}
				opened={openPanels['toc-settings']}
				onToggle={() => onTogglePanel('toc-settings')}
				className="vb-toc-settings-panel"
			>
				<TextControl
					label={__('Title', 'vayu-blocks')}
					__next40pxDefaultSize={true}
					__nextHasNoMarginBottom={true}
					onChange={(value) => setAttributes({tocTitle:value})}
					value={attributes.tocTitle}
				/>

				{/* {isSiteEditor && (
					<SelectControl
						label={__('Insert TOC Position','vayu-blocks')}
						value={attributes.inserterPosition}
						options={[
							{ label: 'Default', value: 'default' },
							{ label: 'Before First Heading', value: 'before-heading' },
							{ label: 'After First Heading', value: 'after-heading' },
							{ label: 'After Secound Heading', value: 'after-second-heading' },
						]}
						onChange={(value) => setAttributes({ inserterPosition: value })}
					/>
				)} */}

				<RangeControl
					label={__('Columns', 'vayu-blocks')}
					value={attributes.columns}
					onChange={(value) => setAttributes({ columns: value })}
					min={1}
					max={4}
					marks
					className="vb-range-toc-panel"
					step={1}
					withInputField={false}
				/>

				<div className="vb-Markers-outer-div">
					<p className="vb-markers-toc">{__('Markers','vayu-blocks')}</p>
					<SlideButton  
						button={{ disc: "Bullets", decimal: "Numbers" }}
						onChange={(value) => setAttributes({ markerStyle: value })}
						defaultValue={attributes.markerStyle}
					/>  
				</div>	

				<SelectControl
					label={__('Separator Style', 'vayu-blocks')}
					value={attributes.separator}
					options={[
						{ label: 'None', value: 'none' },
						{ label: 'Solid', value: 'solid' },
						{ label: 'Double', value: 'double' },
						{ label: 'Dashed', value: 'dashed' },
						{ label: 'Dotted', value: 'dotted' },
					]}
					onChange={(value) => setAttributes({ separator: value })}
				/>

				<br/>

				<HeightControl
					label={__('Spacing Between Content and List', 'vayu-blocks')}
					value={attributes.spacing}
					responsive={true}
					onChange={(value) => setAttributes({ spacing: value })}
					unitMax={{
						px: { max: 100, step: 1 },
						'%': { max: 10, step: 1 },
						vw: { max: 10, step: 1 },
						vh: { max: 10, step: 1 },
						em: { max: 10, step: 0.1 },
						rem: { max: 10, step: 0.1 },
					}}
				/>
 
			</PanelBody>

			<PanelBody
				title={__('Content Collapsible', 'vayu-blocks')}
				opened={openPanels['toc-Collapsible']}
				onToggle={() => onTogglePanel('toc-Collapsible')}
			>

				<VayuBlocksToggleControl
					label={__('Enable Collapsible List', 'vayu-blocks')}
					checked={attributes.enableCollapse}
					onChange={(value) => setAttributes({ enableCollapse: value })}
				/>

				{attributes.enableCollapse  && (
					<>
						<VayuBlocksToggleControl
							label={__('Compact Mode ', 'vayu-blocks')}
							checked={attributes.enableShrink}
							onChange={(value) => setAttributes({ enableShrink: value })}
							help={__('When enabled, the TOC shrinks to fit its title and Content.', 'vayu-blocks')}
						/>

						<RangeControl
							label={__('Max Open Headings', 'vayu-blocks')}
							value={attributes.collapseLimit}
							onChange={(value) => setAttributes({ collapseLimit: value })}
							min={0}
							max={10}
							className="vb-range-toc-panel"
							marks
							step={1}
							withInputField={false}
						/>

						<p className="vb-para-toc-panel">{__('Initial State', 'vayu-blocks')} </p>

						<SlideButton  
							button={{ open: "Open", close: "Close" }}
							onChange={(value) => setAttributes({ collapseBehavior: value })}
							defaultValue={attributes.collapseBehavior}
							label={__('Initial State', 'vayu-blocks')}
						/> 
						
						<div style={{ marginBottom: '10px' }}>
							<p style={{ fontWeight: '500', marginBottom: '6px' }}>{__('Active Icon & Text', 'vayu-blocks')}</p>

							<TextControl
								__next40pxDefaultSize={true}
								__nextHasNoMarginBottom={true}
								onChange={(value) => setAttributes({activetext:value})}
								value={attributes.activetext}
							/>
							<IconSelector
								value={{iconName: attributes.activeiconName}}
								onChange={(val) =>setAttributes({activeiconName: val.iconName})}
							/>
						</div>

						<div>
							<p style={{ fontWeight: '500', marginBottom: '6px' }}>{__('Inactive Icon & Text', 'vayu-blocks')}</p>
							<TextControl
								__next40pxDefaultSize={true}
								__nextHasNoMarginBottom={true}
								onChange={(value) => setAttributes({inactivetext:value})}
								value={attributes.inactivetext}
							/>
							<IconSelector
								value={{iconName: attributes.inactiveiconName}}
								onChange={(val) =>setAttributes({inactiveiconName: val.iconName})}
							/>
						</div>

						<br/>
						<br/>

						<div className='alignment-component-vb'>
							<ToggleGroupControls
								__next40pxDefaultSize={true}
								__nextHasNoMarginBottom={true}
								isBlock
								label={__('Title & Icon Alignment', 'vayu-blocks')}
								value={ attributes.overallalignment}
								onChange={(value)=>setAttributes({overallalignment: value})}
							>
								<ToggleGroupControlOptionIcon
									icon={<Icon icon={ justifyLeft } />}
									label={__('Left', 'vayu-blocks')}
									value="left"
								/>
								<ToggleGroupControlOptionIcon
									icon={<Icon icon={ justifyRight } />}
									label={__('Right', 'vayu-blocks')}
									value="right"
								/>
							</ToggleGroupControls>
						</div>

						<br/>

						<VayuBlocksAlignment
							onChange={(key,value)=>setAttributes({[key]:value})}
							alignment = {{key:'iconalignment',value:attributes.iconalignment}}
							options = {{spaceBetween:__('space-between', 'vayu-blocks')}}
						/>
					</>
				)}

			</PanelBody>

			<PanelBody
				title={__('Scroll', 'vayu-blocks')}
				opened={openPanels['toc-scroll']}
				onToggle={() => onTogglePanel('toc-scroll')}
			>

				<VayuBlocksToggleControl
					label={__('Scroll', 'vayu-blocks')}
					checked={attributes.scroll}
					onChange={(value) => setAttributes({ scroll: value })}
				/>

				{attributes.scroll && (
					<>
						<br/>
						<HeightControl
							label={__('Smooth Scroll Offset', 'vayu-blocks')}
							value={attributes.scrollheight}
							responsive={true}
							onChange={(value) => setAttributes({ scrollheight: value })}
						/>

					</>
				)}

			</PanelBody>

		</>
	);
};

export default Toc;